import { useState, useEffect } from "react";

const useResponsive = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  const checkWindowSize = () => {
    const windowWidth = window.innerWidth;
    setIsMobile(windowWidth <= 767);
    setIsTablet(windowWidth >= 768 && windowWidth <= 1023);
  };

  useEffect(() => {
    window.addEventListener("resize", checkWindowSize);

    // Initial check
    checkWindowSize();

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", checkWindowSize);
    };
  }, []);

  return { isMobile, isTablet };
};

export default useResponsive;
